import { createSlice } from "@reduxjs/toolkit"

const dataSlice = createSlice({
    name: 'data',
    initialState: {userData: null, userSubscription: [], selectedReportId: null, selectedSubscription: null, selectedFrequency: "days", selectedOffset: 0, selectedweekdayOffset: 0, selectedTimeOffset: 0, selectedSubscriptionName: "", selectedFileFormat: "PDF", isSubscriptionActive: true, subscriptionReportId: "", isStandardDB: false, isAdminAnalytics: false, reportFilter: null, reportSearchTxt: "", isEditSubscription: false, downloadStatus: []},
    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload
        },
        setUserSubscription: (state, action) => {
            state.userSubscription = action.payload
        },
        setReportId: (state, action) => {
            state.selectedReportId =  action.payload
        },
        setSelectedSubscription: (state, action) => {
            state.selectedSubscription =  action.payload
        },
        setSelectedFrequency: (state, action) => {
            state.selectedFrequency = action.payload
        },
        setSelectedOffset: (state, action) => {
            state.selectedOffset = action.payload
        },
        setSelectedweekdayOffset: (state, action) => {
            state.selectedweekdayOffset = action.payload
        },
        setSelectedTimeOffset: (state, action) => {
            state.selectedTimeOffset = action.payload
        },
        setSelectedSubscriptionName: (state, action) => {
            state.selectedSubscriptionName = action.payload
        },
        setSelectedFileFormat: (state, action) => {
            state.selectedFileFormat = action.payload
        },
        setIsSubscriptionActive: (state, action) => {
            state.isSubscriptionActive = action.payload
        },
        setSubscriptionReportID: (state, action) => {
            state.subscriptionReportId = action.payload
        },
        setIsStandardDB: (state, action) => {
            state.isStandardDB = action.payload
        },
        setIsAdminAnalytics: (state, action) => {
            state.isAdminAnalytics = action.payload
        },
        setReportFilters: (state, action) => {
            state.reportFilter = action.payload
        },
        setReportSearchTxt: (state, action) => {
            state.reportSearchTxt = action.payload
        },
        setIsEditSubscription: (state, action) => {
            state.isEditSubscription = action.payload
        },
        setPBIReportFolderList: (state, action) => {
            state.reportFolderList = action.payload
        },
       
        setReportEditMode: (state, action) => {
            state.isReportEditMode = action.payload
        },
        setPBIFolderList: (state, action) => {
            state.folderList = action.payload
        },
        setFileDownloadStatus: (state, action) => {
            state.downloadStatus = action.payload
        },
        
    },
})

export const { setUserData, setUserSubscription, setReportId, setSelectedSubscription, setSelectedFrequency, setSelectedOffset, setSelectedweekdayOffset, setSelectedTimeOffset, setSelectedSubscriptionName, setSelectedFileFormat, setIsSubscriptionActive, setSubscriptionReportID, setIsStandardDB, setIsAdminAnalytics, setReportFilters, setReportSearchTxt, setIsEditSubscription ,setPBIReportFolderList,setPBIFolderList, setFileDownloadStatus} = dataSlice.actions

export default dataSlice.reducer

export const selectUserData = (state) => state.data.userData
export const selectUserSubscription = (state) => state.data.userSubscription
export const selectReportId = (state) => state.data.selectedReportId
export const selectSelectedSubscription = (state) => state.data.selectedSubscription
export const selectSelectedFrequency = (state) => state.data.selectedFrequency
export const selectSelectedOffset = (state) => state.data.selectedOffset
export const selectSelectedweekdayOffset = (state) => state.data.selectedweekdayOffset
export const selectSelectedTimeOffset = (state) => state.data.selectedTimeOffset
export const selectSelectedSubscriptionName = (state) => state.data.selectedSubscriptionName
export const selectSelectedFileFormat = (state) => state.data.selectedFileFormat
export const selectIsSubscriptionActive = (state) => state.data.isSubscriptionActive
export const selectSubscriptionReportId = (state) => state.data.subscriptionReportId
export const selectIsStandardDB = (state) => state.data.isStandardDB
export const selectIsAdminAnalytics = (state) => state.data.isAdminAnalytics
export const selectReportFilters = (state) => state.data.reportFilter
export const selectReportSearchTxt = (state) => state.data.reportSearchTxt
export const selectIsEditSubsription = (state) => state.data.isEditSubscription
export const selectPBIFolderList = (state) => state.data.folderList
export const selectReportFolderList = (state) => state.data.reportFolderList
export const selectReportEditMode = (state) => state.data.isReportEditMode
export const selectFileDownloadStatus = (state) => state.data.downloadStatus
